import { CustomComponentProps } from "utils/types/general.types";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Card from "./Card";

export type MyModalProps = CustomComponentProps & {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    children: React.ReactNode;
};

const MyModal = ({
    open,
    setOpen,
    children,
    className,
    style = {}
}: MyModalProps) => {
    return (
        <div
            className={`fixed w-screen h-screen top-0 left-0 px-10 py-10 ${className} ${open ? "flex items-center justify-center" : "hidden"}`}
            style={{ ...style, zIndex: 500 }}
        >
            <div
                className="absolute h-full w-full top-0 left-0 bg-white dark:bg-black opacity-50"
                onClick={() => setOpen(false)}
                style={{ zIndex: 1 }}
            ></div>
            <Card
                className="relative flex flex-col w-full max-h-full md:w-9/12 lg:w-8/12 overflow-y-auto my-modal-card"
                style={{ zIndex: 2 }}
            >
                <div className="w-full flex justify-end">
                    <div className="rounded-full">
                        <CloseRoundedIcon
                            fontSize="small"
                            onClick={() => setOpen(false)}
                            className="cursor-pointer dark:text-white"
                        />
                    </div>
                </div>
                {children}
            </Card>
        </div>
    );
};

export default MyModal;
